import { render, staticRenderFns } from "./ListSearch.vue?vue&type=template&id=3b81c970&"
import script from "./ListSearch.vue?vue&type=script&lang=ts&"
export * from "./ListSearch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports